<template>
  <ul class="nav flex-column pt-5" style="margin-top: 10rem">
    <li v-for="(nav, index) in sideNavs" :key="index" class="nav-item">
      <a class="nav-link" :href="nav.href" target="_blank">
        <font-awesome-icon :icon="nav.icon" />
      </a>
    </li>
  </ul>
</template>

<script>
import axios from "axios";

export default {
  name: "SideNav",
  data() {
    return {
      sideNavs: [
        {
          href: '',
          icon: ["fab", "instagram"],
        },
        {
          href: '',
          icon: ["fab", "facebook"],
        },
        {
          href: "https://goo.gl/maps/AEXe8U43wWpGevxN6",
          icon: ["fas", "map-marker-alt"],
        },
      ],
      social_media: [],
    };
  },

  methods: {
    loadFooter() {
      axios
        .get("/footers")
        .then((response) => {
          this.footer = response.data.data;
          this.setSocialMediaUrls();
        })
        .catch((error) => {
          console.error("Error fetching footers:", error);
        });
    },
    setSocialMediaUrls() {
      if (this.footer) {
        // Find the URLs for Instagram and Facebook in the social_media array
        const instagramData = this.footer.social_media.find(item => item.name === 'Instagram URL');
        const facebookData = this.footer.social_media.find(item => item.name === 'Facebook URL');

        // Set the URLs to the data properties for Instagram and Facebook
        this.instagramUrl = instagramData ? instagramData.url : null;
        this.facebookUrl = facebookData ? facebookData.url : null;

        // Set the URLs to the respective objects in sideNavs array
        if (instagramData) {
          this.sideNavs[0].href = this.instagramUrl;
        }

        if (facebookData) {
          this.sideNavs[1].href = this.facebookUrl;
        }
      }
    }
  },

  mounted() {
    this.loadFooter();
  },
};
</script>

<style scoped>
.nav {
  position: fixed;
  top: 10;
  left: 0;
  width: 30px;
  height: 100%;
  background-color: transparent;
  z-index: 999;
}

.nav-link svg {
  width: 30px;
  height: 30px;
  color: #ffbc0d;
  transition: all 0.3s ease-in-out;
  margin-left: 20px;
}

@media only screen and (max-width: 550px) {
  .nav-link svg {
    display: none;
  }
}

.nav-link:hover svg {
  transform: scale(1.3);
}

ul.nav.flex-column li {
  margin-bottom: 15px;
}

@media screen and (max-width: 768px) {
  .nav-link svg {
    width: 15px;
    height: 15px;
  }
}

@media screen and (max-width: 480px) {
  .nav-link svg {
    width: 15px;
    height: 15px;
  }
}

@media screen and (max-width: 287px) {
  .nav.flex-column {
    display: none;
  }
}
</style>